import React, { useState } from 'react';
import { Calendar, MapPin, Clock, Users, MessageSquare, Award, ArrowRight } from 'lucide-react';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
export const WarriEvent2025 = () => {
  const [activeTab, setActiveTab] = useState('details');
  const eventQuotes = ['Network and Grow', "Don't only use bridges, build them.", "Opportunities don't just knock—they're introduced through people.", 'Give, and Give; it comes back to you in greater measure.'];
  return <div className="pt-20 bg-white" data-id="element-3047">
      {/* Hero Section */}
      <section className="relative py-16 border-b border-gray-300" data-id="element-3048">
        <div className="absolute inset-0 z-0" data-id="element-3049">
          <div className="w-full h-full bg-gray-200 border-2 border-dashed border-gray-400" data-id="element-3050"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3051">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3052">
            <div className="inline-block bg-white border border-gray-300 px-4 py-1 rounded-md text-sm font-bold mb-6" data-id="element-3053">
              UPCOMING EVENT
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" data-id="element-3054">
              Networking Salon: Warri Edition 2025
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-3055">
              Connect with ambitious professionals in Warri and build meaningful
              relationships that unlock new opportunities.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-3056">
              <Button className="border-2 border-gray-800" data-id="element-3057">Register Now</Button>
              <Button variant="outline" className="border-2 border-gray-400" data-id="element-3058">
                Learn More
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Event Details Section */}
      <section className="py-12 border-b border-gray-300" data-id="element-3059">
        <div className="container mx-auto px-4" data-id="element-3060">
          <div className="max-w-4xl mx-auto" data-id="element-3061">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-3062">
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-3063">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-3064">
                  <Calendar size={24} className="text-gray-700" data-id="element-3065" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-3066">Date</h3>
                <p className="text-gray-600" data-id="element-3067">August 30, 2025</p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-3068">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-3069">
                  <MapPin size={24} className="text-gray-700" data-id="element-3070" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-3071">Venue</h3>
                <p className="text-gray-600" data-id="element-3072">Deluxe á la Carte Restaurant</p>
                <p className="text-gray-600" data-id="element-3073">Warri, Nigeria</p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-3074">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-3075">
                  <Clock size={24} className="text-gray-700" data-id="element-3076" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-3077">Time</h3>
                <p className="text-gray-600" data-id="element-3078">4:00 PM - 7:00 PM</p>
              </div>
            </div>
            <div className="border-2 border-gray-300 rounded-lg overflow-hidden mb-8" data-id="element-3079">
              <div className="flex border-b border-gray-300" data-id="element-3080">
                <button className={`px-6 py-3 font-medium ${activeTab === 'details' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('details')} data-id="element-3081">
                  Event Details
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'agenda' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('agenda')} data-id="element-3082">
                  Agenda
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'speakers' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('speakers')} data-id="element-3083">
                  Speakers
                </button>
              </div>
              <div className="p-6" data-id="element-3084">
                {activeTab === 'details' && <div data-id="element-3085">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3086">
                      About This Event
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-3087">
                      Join us for an evening of meaningful connections,
                      inspiring conversations, and opportunities in Warri. The
                      Networking Salon brings together ambitious professionals,
                      entrepreneurs, and changemakers to build relationships
                      that matter.
                    </p>
                    <p className="text-gray-600 mb-4" data-id="element-3088">
                      This special edition will focus on creating strategic
                      connections among Warri's growing professional community,
                      with structured networking activities, curated
                      discussions, and opportunities to share ideas.
                    </p>
                    <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3089">
                      <div className="border border-gray-300 rounded-lg p-4 flex items-start" data-id="element-3090">
                        <Users size={20} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-3091" />
                        <div data-id="element-3092">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-3093">
                            Who Should Attend
                          </h4>
                          <p className="text-gray-600" data-id="element-3094">
                            Professionals, entrepreneurs, creatives, and
                            change-makers ages 18-45
                          </p>
                        </div>
                      </div>
                      <div className="border border-gray-300 rounded-lg p-4 flex items-start" data-id="element-3095">
                        <Award size={20} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-3096" />
                        <div data-id="element-3097">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-3098">
                            What You'll Gain
                          </h4>
                          <p className="text-gray-600" data-id="element-3099">
                            Strategic connections, visibility, and access to
                            opportunities
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>}
                {activeTab === 'agenda' && <div data-id="element-3100">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3101">
                      Event Agenda
                    </h3>
                    <div className="space-y-6" data-id="element-3102">
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-3103">
                        <div className="flex items-center mb-2" data-id="element-3104">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-3105">
                            <span className="text-gray-700 font-bold" data-id="element-3106">1</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-3107">
                            4:00 PM - 4:30 PM: Registration & Welcome
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-3108">
                          Check-in, receive your name tag, and enjoy welcome
                          refreshments
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-3109">
                        <div className="flex items-center mb-2" data-id="element-3110">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-3111">
                            <span className="text-gray-700 font-bold" data-id="element-3112">2</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-3113">
                            4:30 PM - 5:00 PM: Keynote Session
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-3114">
                          Opening remarks and keynote presentation on building
                          powerful networks
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-3115">
                        <div className="flex items-center mb-2" data-id="element-3116">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-3117">
                            <span className="text-gray-700 font-bold" data-id="element-3118">3</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-3119">
                            5:00 PM - 6:00 PM: Structured Networking
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-3120">
                          Guided networking activities designed to create
                          meaningful connections
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-3121">
                        <div className="flex items-center mb-2" data-id="element-3122">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-3123">
                            <span className="text-gray-700 font-bold" data-id="element-3124">4</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-3125">
                            6:00 PM - 6:45 PM: Panel Discussion
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-3126">
                          Industry leaders share insights on opportunities in
                          Warri and beyond
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-3127">
                        <div className="flex items-center mb-2" data-id="element-3128">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-3129">
                            <span className="text-gray-700 font-bold" data-id="element-3130">5</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-3131">
                            6:45 PM - 7:00 PM: Closing & Next Steps
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-3132">
                          Wrap-up, next steps, and information about future
                          events
                        </p>
                      </div>
                    </div>
                  </div>}
                {activeTab === 'speakers' && <div data-id="element-3133">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3134">
                      Featured Speakers
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3135">
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-3136">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-3137"></div>
                        <div data-id="element-3138">
                          <h4 className="font-bold text-gray-800" data-id="element-3139">
                            Andrew Igbineweka
                          </h4>
                          <p className="text-gray-600" data-id="element-3140">
                            Founder, The Networking Salon
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-3141">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-3142"></div>
                        <div data-id="element-3143">
                          <h4 className="font-bold text-gray-800" data-id="element-3144">
                            Local Lead
                          </h4>
                          <p className="text-gray-600" data-id="element-3145">Warri City Ambassador</p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-3146">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-3147"></div>
                        <div data-id="element-3148">
                          <h4 className="font-bold text-gray-800" data-id="element-3149">
                            Guest Speaker
                          </h4>
                          <p className="text-gray-600" data-id="element-3150">Industry Expert</p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-3151">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-3152"></div>
                        <div data-id="element-3153">
                          <h4 className="font-bold text-gray-800" data-id="element-3154">
                            Panel Moderator
                          </h4>
                          <p className="text-gray-600" data-id="element-3155">Community Leader</p>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Event Highlights */}
      <section className="py-12 border-b border-gray-300" data-id="element-3156">
        <div className="container mx-auto px-4" data-id="element-3157">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-8" data-id="element-3158">
            Event Highlights
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-3159">
            <div className="relative aspect-[4/3] border-2 border-dashed border-gray-400 rounded-lg overflow-hidden" data-id="element-3160">
              <div className="absolute inset-0 bg-gray-100 flex items-center justify-center" data-id="element-3161">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-3162">
                  <MessageSquare size={32} className="text-gray-500" data-id="element-3163" />
                </div>
              </div>
            </div>
            <div data-id="element-3164">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3165">
                Inspiring Conversations
              </h3>
              <div className="space-y-4" data-id="element-3166">
                {eventQuotes.map((quote, index) => <div key={index} className="border-l-2 border-gray-400 pl-4" data-id="element-3167">
                    <p className="text-gray-700 font-medium" data-id="element-3168">{quote}</p>
                  </div>)}
              </div>
              <div className="mt-6" data-id="element-3169">
                <p className="text-gray-600" data-id="element-3170">
                  Join us at Deluxe á la Carte Restaurant in Warri for an
                  evening of meaningful networking and inspiration. Connect with
                  like-minded professionals and discover new opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Registration Section */}
      <section className="py-12 border-b border-gray-300 bg-gray-50" data-id="element-3171">
        <div className="container mx-auto px-4" data-id="element-3172">
          <div className="max-w-3xl mx-auto text-center" data-id="element-3173">
            <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-3174">
              Secure Your Spot
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-3175">
              Limited seats available. Register now to join The Networking Salon
              Warri Edition.
            </p>
            <div className="border-2 border-gray-300 rounded-lg p-6 bg-white mb-8" data-id="element-3176">
              <div className="flex justify-center mb-6" data-id="element-3177">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-3178">
                  <Award size={32} className="text-gray-700" data-id="element-3179" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-3180">
                Event Registration
              </h3>
              <div className="text-center mb-6" data-id="element-3181">
                <p className="text-3xl font-bold text-gray-800" data-id="element-3182">₦5,000</p>
                <p className="text-gray-600" data-id="element-3183">per person</p>
              </div>
              <ul className="space-y-3 mb-8 text-left max-w-md mx-auto" data-id="element-3184">
                <li className="flex items-start" data-id="element-3185">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-3186">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3187"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-3188">
                    Full access to the networking event
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3189">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-3190">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3191"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-3192">Refreshments and dinner</span>
                </li>
                <li className="flex items-start" data-id="element-3193">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-3194">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3195"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-3196">
                    Professional networking materials
                  </span>
                </li>
                <li className="flex items-start" data-id="element-3197">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-3198">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-3199"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-3200">
                    Access to post-event connections
                  </span>
                </li>
              </ul>
              <Button className="w-full border-2 border-gray-800" data-id="element-3201">
                Register Now
              </Button>
            </div>
            <p className="text-gray-600" data-id="element-3202">
              Inner Circle members receive a special discount.
              <Link to="/membership" className="underline ml-1" data-id="element-3203">
                Learn more about membership
              </Link>
            </p>
          </div>
        </div>
      </section>
      {/* Location Map */}
      <section className="py-12" data-id="element-3204">
        <div className="container mx-auto px-4" data-id="element-3205">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-8" data-id="element-3206">
            Event Location
          </h2>
          <div className="max-w-4xl mx-auto" data-id="element-3207">
            <div className="aspect-[16/9] border-2 border-gray-300 rounded-lg overflow-hidden mb-6" data-id="element-3208">
              <div className="w-full h-full bg-gray-200 flex items-center justify-center" data-id="element-3209">
                <div className="text-center" data-id="element-3210">
                  <MapPin size={48} className="text-gray-400 mx-auto mb-2" data-id="element-3211" />
                  <p className="text-gray-600" data-id="element-3212">
                    Map of Deluxe á la Carte Restaurant, Warri
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3213">
              <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3214">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3215">
                  Venue Details
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-3216">
                  <strong data-id="element-3217">Deluxe á la Carte Restaurant</strong>
                  <br data-id="element-3218" />
                  Warri, Delta State, Nigeria
                </p>
                <p className="text-gray-600" data-id="element-3219">
                  A premium dining venue with excellent facilities for
                  networking events. The restaurant offers a comfortable
                  atmosphere conducive to meaningful conversations and
                  connections.
                </p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-3220">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-3221">
                  Contact Information
                </h3>
                <div className="space-y-4" data-id="element-3222">
                  <p className="text-gray-600" data-id="element-3223">
                    <strong data-id="element-3224">Event Coordinator:</strong>
                    <br data-id="element-3225" />
                    The Networking Salon Team
                    <br data-id="element-3226" />
                    info@thenetworkingsalon.live
                  </p>
                  <p className="text-gray-600" data-id="element-3227">
                    <strong data-id="element-3228">Local Lead:</strong>
                    <br data-id="element-3229" />
                    Warri City Ambassador
                    <br data-id="element-3230" />
                    warri@thenetworkingsalon.live
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-16 bg-gray-50" data-id="element-3231">
        <div className="container mx-auto px-4 text-center" data-id="element-3232">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 max-w-2xl mx-auto" data-id="element-3233">
            Join Us in Warri to Build Connections That Matter
          </h2>
          <Button className="border-2 border-gray-800" data-id="element-3234">
            Register for the Event
            <ArrowRight size={16} className="ml-2" data-id="element-3235" />
          </Button>
        </div>
      </section>
    </div>;
};